import { render, staticRenderFns } from "./UserNotesV2.vue?vue&type=template&id=7723a59e&scoped=true&"
import script from "./UserNotesV2.vue?vue&type=script&lang=js&"
export * from "./UserNotesV2.vue?vue&type=script&lang=js&"
import style0 from "./UserNotesV2.vue?vue&type=style&index=0&id=7723a59e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7723a59e",
  null
  
)

export default component.exports